// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "7875" ? "angular-vendor" : chunkId) + "." + {"2515": "b6aee86f","5154": "65188d38","7875": "806dacb9",}[chunkId] + ".js"
}